import React, { useState } from "react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import TaskTableBox from "./TaskTableBox";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Grid from "@mui/material/Grid";

const ModuleTabelBox = ({
  moduleValue,
  moduleIndex,
  sprintIndex,
  milestoneIndex,
  mileStoneName,
}) => {
  const [taskStatus, setTaskStatus] = useState(false);
  const handleTaskClick = () => {
    setTaskStatus(!taskStatus);
  };
  return (
    <>
      <div className="moduleboardColumn">
        <div className="mileStone-head">
          {taskStatus ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
          <h3 onClick={() => handleTaskClick()}>{moduleValue?.modulename}</h3>
        </div>
        <div></div>
      </div>

      {taskStatus &&
        moduleValue?.tasknames?.map((taskVal, taskIndex) => (
          <TaskTableBox
            key={taskIndex}
            taskvalue={taskVal}
            taskIndex={taskIndex}
            moduleIndex={moduleIndex}
            sprintIndex={sprintIndex}
            milestoneIndex={milestoneIndex}
            mileStoneName={mileStoneName}
          />
        ))}
    </>
  );
};

export default ModuleTabelBox;
